<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button></smr-menu-button>
    </ion-buttons>
    <ion-label slot="start">
      <ion-title> Inventory Count </ion-title>
    </ion-label>

    <ion-buttons slot="end" *ngIf="!isMobile">
      <ion-button
        fill="outline"
        expand="block"
        color="primary"
        routerLink="/inventory/inventory-count/0"
      >
        New Count
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar>
    <ion-searchbar
      class="ion-no-padding"
      type="search"
      animated="true"
      placeholder="Search keywords"
      (input)="search($event)"
    >
    </ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <p-table
    #table
    *ngIf="stats.length != 0"
    dataKey="id"
    [columns]="cols"
    [value]="stats"
    [loading]="isLoading"
    [responsive]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['dateTime','itemName','countType','statusName']"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          <div>
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-stat let-columns="columns">
      <tr
        [routerLink]="['/inventory/inventory-count', stat.ID]"
        [queryParams]="{id: stat.ID}"
        class="sm-inventory-row"
      >
        <td>
          <span class="p-column-title"><b>Name</b></span
          >{{ stat.itemName}}
        </td>
        <td>
          <span class="p-column-title"><b>Date</b></span>
          <span>{{ stat.dateTime | salonMonsterDate: 'ddd, MMM D, Y' }}</span>
        </td>
        <td>
          <span class="p-column-title"><b>Type</b></span>
          <span *ngIf="stat.countType == 'Full'"> Full </span>
          <span *ngIf="stat.countType == 'Partial'"> Partial </span>
        </td>
        <td>
          <span class="p-column-title"><b>Status</b></span>
          <span *ngIf="stat.statusName == 'Completed'" class="completed">
            <b>Completed</b>
          </span>
          <span *ngIf="stat.statusName == 'Paused'" class="paused">
            <b>Paused</b>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="stats.length == 0" style="text-align: center">NO DATA</div>

  <ion-fab
    slot="fixed"
    vertical="bottom"
    horizontal="end"
    *ngIf="isMobile"
    routerLink="/inventory/inventory-count/0"
  >
    <ion-fab-button>
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
